import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "order-form" }
const _hoisted_2 = { class: "order-form order-form-2-cols" }
const _hoisted_3 = { class: "order-form" }
const _hoisted_4 = { class: "order-form" }
const _hoisted_5 = { class: "order-form" }
const _hoisted_6 = {
  key: 0,
  class: "order-form order-form-2-cols"
}
const _hoisted_7 = {
  slot: "label",
  class: "is-centered",
  for: "note"
}
const _hoisted_8 = ["placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", {
    ref: "wrapper",
    class: _normalizeClass({ touched: $setup.isFormSubmitted })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["DeliveryAddress"], {
        "delivery-address-type": $setup.selectedAddress,
        "onUpdate:deliveryAddressType": _cache[0] || (_cache[0] = $event => (($setup.selectedAddress) = $event))
      }, null, 8 /* PROPS */, ["delivery-address-type"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Input"], {
        label: $setup.getTranslationSupportFuneral('label_firstname', $setup.isFuneral),
        placeholder: $setup.getTranslationSupportFuneral('placeholder_firstname', $setup.isFuneral),
        value: $setup.deliveryAddress.firstName,
        required: true,
        "onUpdate:value": _cache[1] || (_cache[1] = (value) => $setup.updateDeliveryAddressField('firstName', value))
      }, null, 8 /* PROPS */, ["label", "placeholder", "value"]),
      _createVNode($setup["Input"], {
        label: $setup.getTranslationSupportFuneral('label_lastname', $setup.isFuneral),
        placeholder: $setup.getTranslationSupportFuneral('placeholder_lastname', $setup.isFuneral),
        value: $setup.deliveryAddress.lastName,
        required: true,
        "onUpdate:value": _cache[2] || (_cache[2] = (value) => $setup.updateDeliveryAddressField('lastName', value))
      }, null, 8 /* PROPS */, ["label", "placeholder", "value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      ($setup.selectedAddress !== 'home')
        ? (_openBlock(), _createBlock($setup["Input"], {
            key: 0,
            label: $setup.getTranslationSupportFuneral('label_company', $setup.isFuneral),
            placeholder: $setup.getTranslationSupportFuneral('placeholder_company', $setup.isFuneral),
            value: $setup.deliveryAddress.company ?? '',
            "max-length": 250,
            required: true,
            "onUpdate:value": _cache[3] || (_cache[3] = (value) => $setup.updateDeliveryAddressField('company', value))
          }, null, 8 /* PROPS */, ["label", "placeholder", "value"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode($setup["AddressAutoComplete"], {
        label: $setup.getTranslationSupportFuneral('label_address', $setup.isFuneral),
        placeholder: $setup.getTranslationSupportFuneral('placeholder_address', $setup.isFuneral),
        "is-form-submitted": $setup.isFormSubmitted,
        labels: {
          zipcode: $setup.getTranslationSupportFuneral('label_zipcode', $setup.isFuneral),
          house_number: $setup.getTranslationSupportFuneral('label_housenumber', $setup.isFuneral),
          extension: $setup.getTranslationSupportFuneral('label_extension', $setup.isFuneral),
          street: $setup.getTranslationSupportFuneral('label_address', $setup.isFuneral),
          city: $setup.getTranslationSupportFuneral('label_city', $setup.isFuneral),
          state: $setup.getTranslationSupportFuneral('label_state', $setup.isFuneral),
          country: $setup.getTranslationSupportFuneral('label_country', $setup.isFuneral),

          searchManual: 'Handmatig invoeren',
          noResults: 'Geen resultaten...',
          reset: 'Reset',
          searchError: 'Oeps! Er ging iets mis met zoeken, probeer het later nogmaals',
        },
        placeholders: {
          zipcode: $setup.getTranslationSupportFuneral('placeholder_zipcode', $setup.isFuneral),
          house_number: $setup.getTranslationSupportFuneral('placeholder_housenumber', $setup.isFuneral),
          extension: $setup.getTranslationSupportFuneral('placeholder_extension', $setup.isFuneral),
          street: $setup.getTranslationSupportFuneral('placeholder_address', $setup.isFuneral),
          city: $setup.getTranslationSupportFuneral('placeholder_city', $setup.isFuneral),
          state: $setup.getTranslationSupportFuneral('placeholder_state', $setup.isFuneral),
          country: $setup.getTranslationSupportFuneral('placeholder_country', $setup.isFuneral),
        },
        "onUpdate:modelValue": _cache[4] || (_cache[4] = (address) => $setup.updateDeliveryAddress(address))
      }, null, 8 /* PROPS */, ["label", "placeholder", "is-form-submitted", "labels", "placeholders"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode($setup["Input"], {
        label: $setup.getTranslationSupportFuneral('label_phoneRecipient', $setup.isFuneral),
        placeholder: $setup.getTranslationSupportFuneral('placeholder_phoneRecipient', $setup.isFuneral),
        value: $setup.deliveryAddress.phoneNumber ?? '',
        "max-length": 30,
        "onUpdate:value": _cache[5] || (_cache[5] = (value) => $setup.updateDeliveryAddressField('phoneNumber', value))
      }, null, 8 /* PROPS */, ["label", "placeholder", "value"])
    ]),
    ($setup.isFuneral)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode($setup["DateInput"], {
            label: $setup.getTranslation('label_funeralDate'),
            placeholder: $setup.getTranslation('placeholder_funeralDate'),
            "model-value": $setup.deliveryAddress.funeralDate,
            "min-date": new Date(),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = (value) => $setup.updateDeliveryAddressField('funeralDate', value))
          }, null, 8 /* PROPS */, ["label", "placeholder", "model-value", "min-date"]),
          _createVNode($setup["TimeInput"], {
            label: $setup.getTranslation('label_funeralDateTime'),
            placeholder: $setup.getTranslation('placeholder_funeralDateTime'),
            modelValue: $setup.deliveryAddress.funeralTime,
            "onUpdate:modelValue": [
              _cache[7] || (_cache[7] = $event => (($setup.deliveryAddress.funeralTime) = $event)),
              _cache[8] || (_cache[8] = (value) => $setup.updateDeliveryAddressField('funeralTime', value))
            ]
          }, null, 8 /* PROPS */, ["label", "placeholder", "modelValue"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("y-input-wrapper", null, [
      _createElementVNode("label", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString($setup.getTranslationSupportFuneral('label_notes', $setup.isFuneral)), 1 /* TEXT */),
        _createVNode($setup["TooltipProvider"], null, {
          default: _withCtx(() => [
            _createVNode($setup["Tooltip"], null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.getTranslationSupportFuneral('tooltip_notes', $setup.isFuneral)), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _withDirectives(_createElementVNode("textarea", {
        class: "order-form__input-textarea",
        name: "note",
        placeholder: $setup.getTranslationSupportFuneral('placeholder_notes', $setup.isFuneral),
        style: {"resize":"vertical"},
        "onUpdate:modelValue": [
          _cache[9] || (_cache[9] = $event => (($setup.cardNote) = $event)),
          _cache[10] || (_cache[10] = (value) => $setup.updateCartNotes(value))
        ]
      }, null, 8 /* PROPS */, _hoisted_8), [
        [_vModelText, $setup.cardNote]
      ])
    ])
  ], 2 /* CLASS */))
}